var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDentalid(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.216,
    height: 25.579,
    viewBox: "0 0 29.216 25.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4757",
    "data-name": "Group 4757",
    transform: "translate(-53.989 0.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4668",
    "data-name": "Group 4668",
    transform: "translate(53.989 -0.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DentaliD",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M367.785,254.142a1.1,1.1,0,0,1,0,2.19h-8.3a1.1,1.1,0,0,1,0-2.19Zm-4.315-21.2a1.1,1.1,0,0,1,0-2.19h8.3a1.1,1.1,0,0,1,0,2.19Zm.178,3.661a1.1,1.1,0,0,1,0,2.19h-9.3a1.1,1.1,0,0,1,0-2.19Zm-6.323,8.025a1.1,1.1,0,0,1,0-2.19h16.6a1.1,1.1,0,0,1,0,2.19Zm10.3,5.851a1.1,1.1,0,0,1,0-2.19h9.254a1.1,1.1,0,0,1,0,2.19Z",
    transform: "translate(-351.039 -230.753)",
    fill: "#20c3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M369.246,254.142a1.1,1.1,0,1,1-1.1,1.095A1.1,1.1,0,0,1,369.246,254.142Zm-13.512-21.2a1.1,1.1,0,1,1,1.1-1.095A1.1,1.1,0,0,1,355.734,232.943ZM364.7,236.6a1.1,1.1,0,1,1-1.1,1.1A1.1,1.1,0,0,1,364.7,236.6Zm9.913,0a1.087,1.087,0,1,1,0,2.174h-5.529a1.087,1.087,0,1,1,0-2.174ZM376,242.439a1.1,1.1,0,1,1-1.1,1.095A1.1,1.1,0,0,1,376,242.439Zm-15.7,8.041a1.095,1.095,0,1,1,1.1-1.095A1.1,1.1,0,0,1,360.3,250.481Zm-10.109,0a1.095,1.095,0,1,1,0-2.19h5.725a1.1,1.1,0,0,1,0,2.19Zm-1.211-5.851a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,348.978,244.63Z",
    transform: "translate(-347.882 -230.753)",
    fill: "#50f5ae"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDentalid);
export default __webpack_public_path__ + "static/media/logoDentalid.15370adb0d01d542276bb039f82e189a.svg";
export { ForwardRef as ReactComponent };